var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-background-primary has-text-dark",attrs:{"id":"redirectionMessage"}},[_vm._v(_vm._s(_vm.$t("general_notFoundError")))])}
var staticRenderFns = []

export { render, staticRenderFns }